export const useStyles = (theme) => ({
  root: {
    padding: 10,
    display: "flex",
    [theme.breakpoints.down(650)]: { marginBottom: 80 },
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    [theme.breakpoints.down(650)]: { padding: 0 },
  },
  toolbar: {
    display: "flex",
    padding: theme.spacing(0, 1),
    [theme.breakpoints.up(650)]: {
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
  },
  bodyContent: {
    textAlign: "center",
  },
});
